<div mat-dialog-title class="flex flex-row items-center justify-between border-b border-gray-200 px-6 py-2 mb-4">
  <h3 class="flex-1 m-0 font-semibold">{{'editEngagement.triggerButton' | translate}}</h3>
  <flow-button class="absolute right-4 top-3" theme="light" type="button" mat-dialog-close>
    <app-icon stroke="#202020" size="md" iconName="x"></app-icon>
  </flow-button>
</div>

<mat-dialog-content class="overflow-hidden">
  <form [formGroup]="form" class="flex flex-col gap-10">
    <div>
      <mat-label>{{'triggerModal.temperature' | translate}}</mat-label>
      <div class="flex flex-col gap-4 px-4">
        <flow-range-slider
          *ngIf="isChanged"
          [newSelectionValues]="newSelectionValues"
          (temperatureValuesChange)="onTemperatureValuesChange($event)"></flow-range-slider>
      </div>
    </div>
    <div>
      <mat-label>{{'triggerModal.weatherConditions' | translate}}</mat-label>
      <div class="flex flex-row gap-4 py-4">
        <div
          *ngFor="let condition of skyConditionIcons"
          class="flex items-center justify-center ring-1 ring-gray-300 rounded-md p-2 cursor-pointer hover:bg-brand-chathams-blue hover:text-white hover:ring-brand-chathams-blue"
          [matTooltip]="('triggerModal.conditions.' + (condition | lowercase)) | translate"
          [class.selected]="selectedIcons.value.indexOf(condition) !== -1"
          (click)="toggleIcon(condition)">
          <app-icon [ngStyle]="{cursor:'pointer', fill: 'none'}" size="md" color="#202020" [iconName]="condition | lowercase"></app-icon>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<div mat-dialog-actions class="flex flex-row justify-between w-full items-center p-6 pt-0">
  <flow-button theme="secondary" variation="outline" (onClick)="clearTriggers()">{{'global.clearAll' | translate}}</flow-button>
  <flow-button theme="primary" variation="fill" (onClick)="onConfirm()">{{'global.confirm' | translate}}</flow-button>
</div>
